
import Vue from 'vue'
import { defineAbility } from '@casl/ability'
import http from './http'

class Casl {
  constructor () {
    this.store = Vue.observable({
      user: null,
      inscription: null,
      doSingulis: false,
      doOmnibus: false,
    })
    this.ability = null
    this.profileType = ''
    this.isParticipant = false
    this.isCorrector = false
    this.isAdmin = false
  }

  async login ({ user, pass }) {
    const url = http.getApiUrl('/session/login')
    const { data } = await http.core.post(url, { username: user, password: pass })
    localStorage.setItem('jwt', data.token)
    return this.getMe()
  }

  async resetPassword ({ token, password }) {
    const url = http.getApiUrl('/session/password/reset')
    return http.core.post(url, { token, password })
  }

  async requestPassword ({ email }) {
    const url = http.getApiUrl('/session/password/request')
    return http.core.post(url, { email })
  }

  async logout () {
    localStorage.setItem('jwt', '')
    this.store.user = null
    this.ability = null
  }

  async getMe () {
    console.log('[auth]getMe')
    return new Promise((resolve, reject) => {
      http.api.get('/session/me')
        .then(({ data }) => {
          this.store.user = data.user
          this.store.inscription = data.inscription
          this.update()
          resolve(data.user)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  async checkEmail (email) {
    console.log('[auth]checkEmail')
    return new Promise((resolve, reject) => {
      http.api.post('/session/check/email', { email })
        .then(({ data }) => {
          resolve(data.isValid)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  async confirmEmail (token) {
    console.log('[auth]confirmEmail')
    return new Promise((resolve, reject) => {
      http.api.post('/session/confirm/email', { token })
        .then(({ data }) => {
          resolve()
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  async isLogged () {
    console.log('[auth]isLogged')
    if (this.store.user) {
      return new Promise(resolve => resolve(true))
    } else {
      await this.getMe()
      return !!this.store.user
    }
  }

  async getProfileType () {
    console.log('[auth]isLogged')
    if (this.store.user) {
      return this.profileType
    } else {
      await this.getMe()
      return this.profileType
    }
  }

  isLoggedSync () {
    return !!this.store.user
  }

  can (...args) {
    if (!this.ability) {
      return false
    }
    return this.ability.can(...args)
  }

  update () {
    if (!this.store.user) {
      this.ability = null
      return
    }
    this.ability = defineAbility((can) => {
      if (this.store.user.participant.id > 0) {
        this.profileType = 'participant'
        this.isParticipant = true
      }
      if (this.store.user.isAdmin) {
        this.profileType = 'admin'
        this.isAdmin = true
      }
    })
  }

  doSingulis () {
    return this.store.doSingulis
  }

  doOmnibus () {
    return this.store.doOmnibus
  }

  setDoSingulis (val) {
    this.store.doSingulis = val
  }

  setDoOmnibus (val) {
    this.store.doOmnibus = val
  }
}

export default new Casl()
